import axios from 'axios';
import { AppConfig } from 'app.config';
import { splitHash } from 'business-layer/helpers/splitHash';

export interface MappingServiceInterface {
  island_id: string;
  island_mfd_base_url: string;
  island_crm_base_url: string;
}

export const fetchBaseUrl = async (hash: string, forceDomanRequest = true) => {
  let baseUrl = localStorage.getItem('__api_domain');
  const useTestDomain = localStorage.getItem('__use_test_domain'); // for e2e tests or manual domain substitution
  if (useTestDomain && baseUrl) return baseUrl; // to run e2e2 tests

  if (!forceDomanRequest && baseUrl) return baseUrl; // disable mapping service request if needed

  const { propertyHash } = splitHash(hash);
  if (propertyHash) {
    try {
      const { data: responseData } = await axios.get(`${AppConfig.mappingServiceUrl}${propertyHash}`);
      if (responseData.island_mfd_base_url) {
        baseUrl = responseData.island_mfd_base_url;
      }
    } catch (e) {
      console.log('Mapping service returned error, check Network tab for details.');
    }
  }

  if (!baseUrl) baseUrl = AppConfig.apiDomain; // fallback, if at this point we don't know what the domain is
  localStorage.setItem('__api_domain', baseUrl);

  return baseUrl;
}